import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { BlogType } from '@/services/strapi/blogs';
import { getBlogBaseDataList, getBlogTags } from '@/services/strapi/blogs';

export const blog = createQueryKeys('blog', {
  baseDataList: ({
    search,
    pageSize = 20,
    page,
    slugToOmit,
    tagDocumentId,
    blogType,
  }: {
    search?: string;
    pageSize?: number;
    page?: number;
    slugToOmit?: string;
    tagDocumentId?: string;
    blogType: BlogType;
  }) => ({
    queryKey: [search, page, pageSize, slugToOmit, tagDocumentId, blogType],
    queryFn: ({ pageParam = 0 }) => {
      return getBlogBaseDataList({
        offset: page ? page * pageSize : pageParam * pageSize,
        pageSize,
        search,
        slugToOmit,
        tagDocumentId,
        blogType,
      });
    },
  }),
  tags: ({ blogType }: { blogType: BlogType }) => ({
    queryKey: [blogType],
    queryFn: () => getBlogTags({ blogType }),
  }),
});
